export enum KeyStatisticColour {
  Green = 'green',
  Yellow = 'yellow',
}
